<mat-form-field class="w-100 mb-0">
  <mat-label>RSVP / Attendance status</mat-label>
  <mat-select multiple [formControl]="responseFormCtrl" (selectionChange)="onSelectionChange($event)">
    <!-- Display current selections -->
    <mat-select-trigger>
      {{ getSelectionDisplay(currentValue) }}
    </mat-select-trigger>
    <!-- RSVP for future events -->
    <mat-optgroup [label]="'RSVP'" class="event-status-opts">
      <mat-option value="allAttending">
        <i class="fas fa-fw fa-circle-check spacerRight color--green--002"></i> Attending
      </mat-option>
      <mat-option *ngFor="let response of rsvpOptions" [value]="response" class="indent">
        <i class="far fa-fw spacerRight {{ getIconWithColor(response) }}"></i>
        {{ getLabel(response) }}
      </mat-option>
      <mat-option [value]="ResponseEnum.Tentative">
        <i class="far fa-fw spacerRight {{ getIconWithColor(ResponseEnum.Tentative) }}"></i>
        {{ getLabel(ResponseEnum.Tentative) }}
      </mat-option>
      <mat-option [value]="ResponseEnum.Declined" *ngIf="includeDeclined">
        <i class="far fa-fw spacerRight {{ getIconWithColor(ResponseEnum.Declined) }}"></i>
        {{ getLabel(ResponseEnum.Declined) }}
      </mat-option>
    </mat-optgroup>
    <!-- Attendance for past events -->
    <mat-optgroup [label]="'Attendance'" class="event-status-opts">
      <mat-option *ngFor="let response of attendanceOptions" [value]="response">
        <i class="far fa-fw spacerRight {{ getIconWithColor(response) }}"></i>
        {{ getLabel(response) }}
      </mat-option>
    </mat-optgroup>
  </mat-select>
</mat-form-field>
